import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

const chartAndSummaryCommonStyles = {
  backgroundColor: tokens.colorNeutralBackground1,
  ...shorthands.borderRadius(tokens.borderRadiusMedium),
  paddingLeft: tokens.spacingHorizontalS,
  paddingRight: tokens.spacingHorizontalS,
  paddingTop: tokens.spacingVerticalS,
  paddingBottom: tokens.spacingVerticalS,
};

export const useInsightsPanelPreviewStyles = makeStyles({
  root: {
    display: 'flex',
    marginTop: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,

    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground3,
    boxShadow: tokens.shadow2,
  },
  top: {
    display: 'flex',
  },
  header: {
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,

    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    opacity: '0.8',
    backgroundColor: tokens.colorNeutralBackground1,
    backdropFilter: 'blur(2px)',

    ...typographyStyles.caption1Strong,
  },
  chartHeader: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalXS,
  },
  chart: {
    ...chartAndSummaryCommonStyles,
  },
  summary: {
    ...chartAndSummaryCommonStyles,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
  summaryContent: {
    // restrict the height of the summary to 4 lines
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 4,
    overflowY: 'hidden',
    maxHeight: `calc(${tokens.lineHeightBase200} * 4)`,
  },
  goFullButton: {},
});
